import { makeStyles } from "@material-ui/core/styles";

export default makeStyles((theme) => ({
  scroll: {
    backgroundColor: "#FFF",
  },
}));
